import * as React from "react";

type Props = {
    fallback: React.ReactNode;
    children: React.ReactNode;
};

type State = {
    hasError: boolean;
    reloadCount: number;
};

export class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {hasError: false, reloadCount: 0};
    }

    static getDerivedStateFromError(error: Error) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        if (
            this.state.reloadCount < 3 &&
            String(error).includes(
                "TypeError: Failed to fetch dynamically imported module"
            )
        ) {
            this.setState((prevState) => ({
                reloadCount: prevState.reloadCount + 1,
            }));
            location.reload();
        } else {
            // setup sentry
        }
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return this.props.fallback;
        }

        return this.props.children;
    }
}
